import React from "react";
import { Box, Typography, List, ListItem, ListItemText, Divider, Paper } from "@mui/material";
import Sidebar from "./Sidebar";

const NotificationsPage = () => {
  const notifications = [
    { id: 1, message: "New integration added successfully.", time: "2 hours ago" },
    { id: 2, message: "Subscription updated to Pro plan.", time: "1 day ago" },
    { id: 3, message: "Billing cycle will renew in 5 days.", time: "3 days ago" },
  ];

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f9f9f9" }}>

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, padding: 3 }}>
        <Typography variant="h4" gutterBottom>
          Notifications
        </Typography>
        <List sx={{ marginTop: 2 }}>
          {notifications.map((notification) => (
            <React.Fragment key={notification.id}>
              <Paper
                elevation={3}
                sx={{
                  padding: 2,
                  marginBottom: 2,
                  ":hover": {
                    backgroundColor: "#f0f8ff",
                    transform: "scale(1.01)",
                  },
                  transition: "all 0.2s ease-in-out",
                }}
              >
                <ListItem disableGutters>
                  <ListItemText
                    primary={
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {notification.message}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="body2" sx={{ color: "gray" }}>
                        {notification.time}
                      </Typography>
                    }
                  />
                </ListItem>
              </Paper>
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default NotificationsPage;
